import { config } from 'state/product/config'

export const createImage = (product, color) => {

  const image = Object.assign(
    document.createElement('img'), {
      alt: color.colormap ? `${product.name} in ${color.colormap}` : `${product.name}`,
      className: 'lazy',
      src: config.pixel // `${config.urlBase.image}${product.productID}_${color.color.id}.jpg`
    }
  )

  image.setAttribute('data-original', color.url.image)

  return image
}
